import aaDev from './env/environments.aa.development.json'
import exploraDev from './env/environments.explora.development.json'
import collahuasiDev from './env/environments.collahuasi.development.json'
import aaPro from './env/environments.aa.production.json'
import exploraPro from './env/environments.explora.production.json'
import collahuasiPro from './env/environments.collahuasi.production.json'
import modDev from './env/environments.modelacion.development.json'
import modPro from './env/environments.modelacion.production.json'

const getEnvironments = () => {
  const currentEnvironment = process.env.NODE_ENV
  const currentAPP = process.env.VUE_APP_CURRENT_APP

  if (currentEnvironment === 'production') {
    switch (currentAPP) {
      case 'aa':
        return aaPro
      case 'explora':
        return exploraPro
      case 'collahuasi':
        return collahuasiPro
      case 'modelacion':
        return modPro
      default:
        return exploraPro
    }
  } else {
    if (currentEnvironment === 'development') {
      switch (currentAPP) {
        case 'aa':
          return aaDev
        case 'explora':
          return exploraDev
        case 'collahuasi':
          return collahuasiDev
        case 'modelacion':
          return modDev
        default:
          return exploraDev
      }
    } else {
      return exploraDev
    }
  }
}

export { getEnvironments }
